import React from 'react';
import BackButtonIcon from '../../assets/img/back.png';

const BackButton = props => {
  const size = props.width ? { width: props.width, height: props.width } : { width: 30, height: 30 };
  return (
    <>
      <div
        style={{
          cursor: 'pointer',
          ...size,
          ...props.style
        }}
        onClick={props.onClick}
        className={props.className || ''}
      >
        <img src={BackButtonIcon} width={size.width} />
      </div>
    </>
  );
};

export default BackButton;
